class PriceError extends Error {
  constructor(message, price) {
    super(`${message} ${price}`)
    this.name = 'PriceError'
  }
}
export default PriceError
